module.exports = __webpack_public_path__ + "assets/img/1.cc56dc8c.jpg";